import Store from '../store'

export default {

    getSeo(name, lang) {

        return Store.dispatch('getPartnersAsync')
            .then(({partners}) => {

                return partners.find(({code}) => code === name).seo[lang]

            })

    },

    getPartner(name) {

        return Store.dispatch('getPartnersAsync')
            .then(({partners}) => {
                const actualPartner =  partners.find(({code}) => code === name)
                Store.dispatch('updateActualPartner', actualPartner)
                return actualPartner

            })
    }

}
